import React, { useState, useRef } from 'react'

import {priceFormat, processAxiosError, showSuccess, showError} from '../utils/helper'
import {printReceipt} from '../Helpers/receipt'
import logo from '../assets/img/logo.png'
import {getPdf} from "../Helpers/pdf";
import TeyaPaymentModal from './TeyaPaymentModal'
import TeyaRefundModal from './TeyaRefundModal'
import {logCard} from '../utils/cardPaymentLog'

const InvoiceSettingsModal = (props) => {

    const { mode,printType, setPrintType, invoiceType, invoiceCompany, paymentMethod, setPaymentMethod, cartItems, getCartItems, getTotalPrice,discountAmount, clearAll, addCash, cash, inputCash, change, showInvoiceSettingsModal,setShowInvoiceSettingsModal, note, setNote, loyaltyData, loyaltyQuote, refreshLoyaltyQuote, getBaseTotal } = props;
    const [processing, setProcessing] = useState(false)
    const [showCardPaymentModal, setShowCardPaymentModal] = useState(false)
    const [completedPayment, setCompletedPayment] = useState(null)
    const [showRefundModal, setShowRefundModal] = useState(false)
    // Kotacija potvrdena neposredno prije naplate — po njoj se naplacuje i po njoj se salje /sales.
    const [confirmedQuote, setConfirmedQuote] = useState(null)
    // Potvrda kotacije je mrezni poziv PRIJE nego printAndProceed digne `processing`.
    // Bez ove brave dvoklik na ZAVRSI ispali dva toka naplate kroz taj prozor.
    const [confirming, setConfirming] = useState(false)
    const finishingRef = useRef(false)
    const moneys = [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200]

    /**
     * Iznos za naplatu iz mjerodavne kotacije. Kotacija se prosljeduje izricito jer se
     * React state osvjezi tek u sljedecem renderu, a naplata krece odmah nakon dohvata.
     */
    const totalFromQuote = (quote) => {
        const base = getBaseTotal ? getBaseTotal() : parseFloat(getTotalPrice(true))
        const total = base - (quote ? parseFloat(quote.total_discount) || 0 : 0)

        return (base < 0 ? total : Math.max(0, total)).toFixed(2)
    }

    /**
     * Osvjezi loyalty izracun neposredno prije naplate. Kosarica se mogla promijeniti
     * otkad je loyalty primijenjen, a naplacuje se tocno ono sto ce zavrsiti na racunu.
     * Vraca {ok, quote} — na neuspjeh se naplata NE smije nastaviti.
     */
    const confirmQuote = async () => {
        if (!loyaltyData || !refreshLoyaltyQuote) {
            setConfirmedQuote(null)

            return {ok: true, quote: null}
        }

        const quote = await refreshLoyaltyQuote()

        if (!quote) {
            logCard('LOYALTY_QUOTE_FAIL', 'Neuspjelo osvjezavanje loyalty izracuna prije naplate', {
                member_id: loyaltyData.memberId,
            })
            showError('Nije moguće potvrditi loyalty popust. Provjerite vezu i pokušajte ponovno.')

            return {ok: false, quote: null}
        }

        setConfirmedQuote(quote)

        return {ok: true, quote}
    }

    const getInvoiceDevice = () => {
        try {
            return JSON.parse(localStorage.getItem('invoiceDevice') || '{}')
        } catch {
            return {}
        }
    }

    const isCardProcessorFlagOn = (device) => {
        const flag = device?.has_card_processor
        return flag === true || flag === 1 || flag === '1' || flag === 'true'
    }

    const hasCardProcessor = () => isCardProcessorFlagOn(getInvoiceDevice())

    /**
     * Zastavica o terminalu zivi u localStorageu i osvjezava se samo pri pokretanju
     * aplikacije. Kasa koja danima stoji otvorena nosi zastarjeli zapis, pa je prije
     * odustajanja od kartice treba provjeriti na serveru.
     * Vraca osvjezeni zapis blagajne ili null ako se nije uspjelo dohvatiti.
     */
    const refreshInvoiceDevice = async () => {
        const current = getInvoiceDevice()
        if (!current?.id) return null

        try {
            const response = await window.axios.get('/invoice-devices')
            const devices = response?.data?.data
            if (!Array.isArray(devices)) return null

            const fresh = devices.find((d) => d.id === current.id)
            if (!fresh) return null

            global.invoiceDevice = fresh
            localStorage.setItem('invoiceDevice', JSON.stringify(fresh))

            return fresh
        } catch {
            return null
        }
    }

    const printAndProceed = async (cardTransactionId = null, gatewayPaymentId = null, cardAmount = null, manualApprovalCode = null, quote = undefined, manualGatewayPaymentId = null) => {
        setProcessing(true)

        // undefined = pozivatelj nije prosljedio kotaciju pa je uzimamo iz statea (vec je slegao);
        // null je valjana vrijednost i znaci "nema loyaltyja".
        const activeQuote = quote === undefined ? confirmedQuote : quote

        const payload = {
            payment_method: paymentMethod,
            type: invoiceType,
            print: printType,
            company: invoiceCompany,
            total: getTotalPrice(),
            total_with_discount: totalFromQuote(activeQuote),
            discount: discountAmount,
            cash: cash,
            note: note,
            change: change,
            mode: mode,
            products: getCartItems()
        }

        if (cardTransactionId) {
            payload.card_processor_transaction_id = cardTransactionId
        }

        if (gatewayPaymentId) {
            payload.card_processor_gateway_payment_id = gatewayPaymentId
        }

        if (cardAmount !== null && cardAmount !== undefined) {
            payload.card_processor_amount = cardAmount
        }

        // Ručno izdavanje (override): kod odobrenja s terminal-slipa (prazan string = nema slipa → pos-blank).
        if (manualApprovalCode !== null && manualApprovalCode !== undefined) {
            payload.card_manual_approval_code = manualApprovalCode
        }

        // Naplata koju je blagajna prije izdavanja potvrdila kod Teye — bez toga ručni
        // račun ostaje bez traga po kojem bi se povrat mogao napraviti.
        if (manualGatewayPaymentId) {
            payload.card_manual_gateway_payment_id = manualGatewayPaymentId
        }

        // Salju se samo ULAZI loyaltyja — iznose racuna server (LoyaltyService::quote()).
        if (loyaltyData) {
            payload.loyalty_member_id = loyaltyData.memberId
            if (loyaltyData.pointsToSpend > 0) {
                payload.loyalty_points_spend = loyaltyData.pointsToSpend
            }
            if (loyaltyData.couponCode) {
                payload.loyalty_coupon_code = loyaltyData.couponCode
            }
            // /sales ovo polje cita kao PREKIDAC (je li VIP ukljucen), a iznos preracuna sam.
            if (activeQuote && parseFloat(activeQuote.vip_discount) > 0) {
                payload.loyalty_vip_discount = parseFloat(activeQuote.vip_discount)
            }
        }

        logCard('SALE_POST', `Slanje /sales (payment_method=${paymentMethod}, total=${payload.total_with_discount})`, {
            payment_method: paymentMethod,
            total: payload.total_with_discount,
            loyalty_discount: activeQuote ? activeQuote.total_discount : 0,
            card_processor_transaction_id: cardTransactionId,
            card_processor_gateway_payment_id: gatewayPaymentId,
            card_processor_amount: cardAmount,
        })

        // Store to database
        await window.axios.post('/sales', payload)
        .then((response) => {
            setProcessing(false)

            //console.log(response)
            if(response.status === 201 && response.data.success === true) {
                //console.log(response.data.data)
                logCard('SALE_OK', `Račun upisan id=${response.data?.data?.id || '?'}`, {
                    sale_id: response.data?.data?.id,
                    invoice_real_id: response.data?.data?.invoice_real_id,
                    had_card_payment: !!cardTransactionId,
                })
                setCompletedPayment(null)
                showSuccess('Račun uspješno izdan!')
                if( printType === "P") {
                    getPdf(response.data.data.invoice_pdf)

                } else {
                    printReceipt(response.data.data)

                }
                clearAll()
                //logout()
                //setShowReceiptModal(false)
            } else if(response.status === 200 && response.data.success === false) {
                console.log(response.data)
                logCard('SALE_FAIL', response.data?.error || 'success=false', {
                    response_data: response.data,
                    had_card_payment: !!cardTransactionId,
                })
                showError(response.data.error)

            } else{
                logCard('SALE_FAIL', `Neočekivani status ${response.status}`, {
                    http_status: response.status,
                    had_card_payment: !!cardTransactionId,
                })
                showError('Došlo je do greške! Error: ' + response.status)
            }
        })
        .catch((error) => {
            setProcessing(false)
            logCard('SALE_ERR', error?.message || 'axios error', {
                http_status: error?.response?.status,
                response_data: error?.response?.data,
                had_card_payment: !!cardTransactionId,
                card_processor_transaction_id: cardTransactionId,
                card_processor_gateway_payment_id: gatewayPaymentId,
            })
            processAxiosError(error)
        })
    }

    const handleFinishClick = async () => {
        // Brava kroz ref, ne kroz state: dva klika u istom tickom ne bi vidjela azuriran state.
        if (finishingRef.current || processing) return
        finishingRef.current = true
        setConfirming(true)

        try {
            const device = getInvoiceDevice()
            const flagRaw = device.has_card_processor
            logCard('FINISH_CLICK', `payment_method=${paymentMethod} has_card_processor=${flagRaw} (${typeof flagRaw}) completedPayment=${!!completedPayment}`, {
                payment_method: paymentMethod,
                has_card_processor: flagRaw,
                has_card_processor_type: typeof flagRaw,
                has_completed_payment: !!completedPayment,
                invoice_device_id: device.id,
            })

            // Mjerodavan iznos se potvrduje PRIJE bilo kakve naplate — i za karticu i za gotovinu.
            const {ok, quote} = await confirmQuote()
            if (!ok) return

            if (paymentMethod === 'R') {
                // Kartice na rate: naplata ide rucno na terminalu za rate, izvan Teya integracije.
                // Racun se izdaje odmah, bez karticnog dijaloga i bez payment zapisa.
                logCard('FINISH_BRANCH', 'installments_no_terminal')
                printAndProceed(null, null, null, null, quote)
            } else if (paymentMethod !== 'K') {
                logCard('FINISH_BRANCH', 'direct_print_no_terminal')
                printAndProceed(null, null, null, null, quote)
            } else if (completedPayment) {
                // Plaćanje je već izvršeno, koristi postojeće transaction ID-jeve
                // (kod ručnog izdavanja prenesi i kod odobrenja da se ne izgubi pri ponovnom slanju).
                logCard('FINISH_BRANCH', 'reuse_completed_payment', { transactionId: completedPayment.transactionId, amount: completedPayment.amount })
                printAndProceed(completedPayment.transactionId, completedPayment.gatewayPaymentId, completedPayment.amount, completedPayment.approvalCode ?? null, quote, completedPayment.manualGatewayPaymentId ?? null)
            } else if (hasCardProcessor()) {
                logCard('FINISH_BRANCH', 'open_card_modal')
                setShowCardPaymentModal(true)
            } else {
                /*
                 * Kartica bez vidljivog terminala. Ranije je ovaj slucaj padao u istu granu
                 * kao gotovina: racun bi se ispisao kao placen karticom, a terminal se ne bi
                 * ni kontaktirao — roba izade, naplate nema, i nista se ne javi.
                 * (Ilica 30.07.2026., pet racuna u devet minuta, 93,20 EUR.)
                 * Zastavica je najcesce samo zastarjela, pa je prvo provjeri na serveru.
                 */
                const fresh = await refreshInvoiceDevice()

                if (isCardProcessorFlagOn(fresh)) {
                    logCard('FINISH_BRANCH', 'card_processor_recovered', { invoice_device_id: fresh.id })
                } else {
                    logCard('FINISH_BRANCH', 'card_blocked_no_terminal', {
                        invoice_device_id: device.id,
                        refreshed: fresh !== null,
                    })
                }

                // U oba slucaja ide kroz karticni dijalog: ili naplati, ili blagajnik svjesno
                // potvrdi rucno izdavanje uz kod odobrenja. Tihi ispis vise nije moguc.
                setShowCardPaymentModal(true)
            }
        } finally {
            finishingRef.current = false
            setConfirming(false)
        }
    }

    const handleCardPaymentSuccess = (transactionId, gatewayPaymentId) => {
        setShowCardPaymentModal(false)
        const chargedAmount = totalFromQuote(confirmedQuote)
        setCompletedPayment({ transactionId, gatewayPaymentId, amount: chargedAmount })
        printAndProceed(transactionId, gatewayPaymentId, chargedAmount)
    }

    const handleCardPaymentManual = (approvalCode, manualGatewayPaymentId = null) => {
        setShowCardPaymentModal(false)
        const chargedAmount = totalFromQuote(confirmedQuote)
        // Ručno izdavanje: nema POSLink transaction_id; kod odobrenja i gateway id potvrđene
        // naplate idu u zasebna polja (spremljeni i u completedPayment da se ne izgube ako
        // se /sales mora ponoviti).
        const code = approvalCode || ''
        setCompletedPayment({ transactionId: null, gatewayPaymentId: null, amount: chargedAmount, manual: true, approvalCode: code, manualGatewayPaymentId })
        logCard('CARD_MANUAL', 'Ručno izdavanje kartičnog računa (override)', {
            approval_code: code || '(nema slipa)',
            amount: chargedAmount,
            gateway_payment_id: manualGatewayPaymentId,
        })
        printAndProceed(null, null, chargedAmount, code, undefined, manualGatewayPaymentId)
    }

    const handleCardPaymentCancel = () => {
        setShowCardPaymentModal(false)
    }

    const handleRefundSuccess = () => {
        setShowRefundModal(false)
        setCompletedPayment(null)
        showSuccess('Povrat na karticu uspješno izvršen!')
    }

    const handleRefundCancel = () => {
        setShowRefundModal(false)
    }

    const amountMismatch = completedPayment && parseFloat(completedPayment.amount) !== parseFloat(getTotalPrice(true))

    // Razlomak popusta za prikaz — sve iz serverske kotacije, nista se ne racuna ovdje.
    const quoteVip = parseFloat(loyaltyQuote?.vip_discount) || 0
    const quotePoints = parseFloat(loyaltyQuote?.points_discount) || 0
    const quoteCoupon = parseFloat(loyaltyQuote?.coupon_discount) || 0
    const quoteTotal = parseFloat(loyaltyQuote?.total_discount) || 0

    return (
        <>
            { showInvoiceSettingsModal &&
            <>
                <div className="hide-print fixed w-full h-screen left-0 top-0 z-10 flex flex-wrap justify-center content-center p-24">
                    <div onClick={() => setShowInvoiceSettingsModal(false)} className="fixed glass w-full h-screen left-0 top-0 z-0 opacity-100"></div>
                    <div className="w-96 rounded-sm bg-white shadow-xl overflow-hidden z-10 opacity-100 scale-100">
            <div className="text-left w-full text-sm p-6 overflow-auto">
                <div className="text-center">
                    <img src={logo} alt="Blagajna" className="w-10 m-auto filter grayscale" />
                    <h2 className="text-xl font-semibold">Maskice.hr</h2>
                    <p>Odaberite vrstu plaćanja</p>
                </div>
                <div className="flex mt-2 text-xs">

                        <div className="relative w-full max-w-full mx-auto mt-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute top-0 bottom-0 w-5 h-5 my-auto text-gray-400 right-3"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <select
                              value={paymentMethod}
                              onChange={e => setPaymentMethod(e.target.value)}
                              disabled={!!completedPayment}
                              className="w-full px-3 py-2 text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none appearance-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2 disabled:bg-gray-100 disabled:cursor-not-allowed">
                             <option key={'G'} value={'G'}>Novčanice</option>
                              <option key={'K'} value={'K'}>Kartice</option>
                              <option key={'R'} value={'R'}>Kartice na rate</option>
{/*                              <option key={'T'} value={'T'}>Transakcijski račun</option>
                              <option key={'C'} value={'C'}>Čekovi</option>
                              <option key={'O'} value={'O'}>Ostalo</option>*/}
                          </select>
                        </div>
                    </div>

                {paymentMethod === 'R' && (
                    <div className="mt-3 px-3 py-2 rounded-lg border bg-violet-50 border-violet-200 text-xs text-violet-800">
                        <div className="font-semibold">Kreditne kartice - poslovnice na rate</div>
                        <p className="mt-1">
                            Blagajna <span className="font-semibold">ne pokreće Teya terminal</span>. Naplatu na rate
                            obavite ručno na terminalu za rate, pa tek onda završite račun.
                        </p>
                    </div>
                )}

                {completedPayment && (
                    <div className={`mt-3 px-3 py-2 rounded-lg border ${amountMismatch ? 'bg-red-50 border-red-300' : 'bg-green-50 border-green-200'}`}>
                        <div className="flex items-center gap-2">
                            {amountMismatch ? (
                                <svg className="w-5 h-5 text-red-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            ) : (
                                <svg className="w-5 h-5 text-green-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                </svg>
                            )}
                            <span className={`text-sm font-medium ${amountMismatch ? 'text-red-700' : 'text-green-700'}`}>
                                Kartica naplaćena: {priceFormat(completedPayment.amount)}
                            </span>
                        </div>
                        {amountMismatch && (
                            <p className="text-xs text-red-600 mt-1 ml-7">
                                Iznos u košarici ({priceFormat(getTotalPrice(true))}) se razlikuje od naplaćenog iznosa. Stornirajte plaćanje pa ponovite naplatu.
                            </p>
                        )}
                        <button
                            onClick={() => setShowRefundModal(true)}
                            disabled={processing}
                            className="mt-2 w-full py-1.5 px-3 text-sm font-medium text-red-700 bg-red-100 hover:bg-red-200 border border-red-300 rounded-lg transition-colors disabled:opacity-50"
                        >
                            Storniraj plaćanje
                        </button>
                    </div>
                )}

                <hr className="my-2" />

          <div className="select-none h-auto w-full text-center pt-3 pb-4">
            {/* Invoice type badge */}
            <div className="flex justify-center mb-3">
              <div className="flex items-center gap-2 flex-wrap justify-center">
                <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                  invoiceType === 'R1' ? 'bg-blue-100 text-blue-800' :
                  invoiceType === 'E' ? 'bg-green-100 text-green-800' :
                  'bg-gray-100 text-gray-800'
                }`}>
                  {invoiceType === 'G' && 'Maloprodajni račun'}
                  {invoiceType === 'R1' && 'R1 račun'}
                  {invoiceType === 'E' && 'E-račun'}
                </span>
                <span className={`px-3 py-1 rounded-full text-sm font-semibold ${
                  paymentMethod === 'K' ? 'bg-amber-100 text-amber-800' :
                  paymentMethod === 'R' ? 'bg-violet-100 text-violet-800' :
                  'bg-emerald-100 text-emerald-800'
                }`}>
                  {paymentMethod === 'K' ? 'Kartica' : paymentMethod === 'R' ? 'Kartice na rate' : 'Gotovina'}
                </span>
                {(invoiceType === 'R1' || invoiceType === 'E') && invoiceCompany?.company && (
                  <div className="relative group">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500 hover:text-gray-700 cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block z-50">
                      <div className="bg-gray-800 text-white text-xs rounded-lg py-2 px-3 whitespace-nowrap shadow-lg">
                        <div className="font-semibold mb-1">{invoiceCompany.company}</div>
                        {invoiceCompany.oib && <div>OIB: {invoiceCompany.oib}</div>}
                        {invoiceCompany.address && <div>{invoiceCompany.address}</div>}
                        {(invoiceCompany.zip || invoiceCompany.city) && (
                          <div>{invoiceCompany.zip} {invoiceCompany.city}</div>
                        )}
                        {invoiceCompany.country && <div>{invoiceCompany.country}</div>}
                      </div>
                      <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Price breakdown */}
            {(parseFloat(discountAmount) > 0 || loyaltyData) ? (
              <>
                <div className="flex mb-1 text-sm text-blue-gray-500">
                  <div>Iznos</div>
                  <div className="text-right w-full">
                    {cartItems.length === 0 ? priceFormat(0) : priceFormat(getTotalPrice(false))}
                  </div>
                </div>
                {parseFloat(discountAmount) > 0 && (
                <div className="flex mb-1 text-sm text-red-500">
                  <div>Popust</div>
                  <div className="text-right w-full">
                    -{priceFormat(discountAmount)}
                  </div>
                </div>
                )}
                {loyaltyData && quoteTotal > 0 && (
                  <div className="flex mb-1 text-sm text-green-600">
                    <div>Loyalty popust</div>
                    <div className="text-right w-full">
                      -{priceFormat(quoteTotal)}
                    </div>
                  </div>
                )}
                <hr className="my-2" />
              </>
            ) : null}

            {loyaltyData && (
              <div className="mb-2 px-2 py-1.5 bg-green-50 border border-green-200 rounded text-xs text-green-800">
                <div className="font-semibold">{loyaltyData.memberName} ({loyaltyData.cardNumber})</div>
                {quoteVip > 0 && <div>VIP -{loyaltyQuote.vip_percent}%: -{priceFormat(quoteVip)}</div>}
                {quotePoints > 0 && <div>Bodovi: -{loyaltyQuote.points_spend} ({priceFormat(quotePoints)})</div>}
                {loyaltyData.couponCode && <div>Kupon: {loyaltyData.couponCode} (-{priceFormat(quoteCoupon)})</div>}
                <div>Zarada: +{(() => {
                    const total = Math.max(0, parseFloat(getTotalPrice(true)) || 0)
                    const pct = parseFloat(loyaltyData.earnPercentage) || 10
                    return Math.round(total * pct) / 100
                })()} bodova</div>
              </div>
            )}

            <div className="flex mb-3 text-lg font-semibold text-blue-gray-700">
              <div>UKUPNO</div>
              <div className="text-right w-full">
                {cartItems.length === 0
                  ? priceFormat(0)
                  : priceFormat(getTotalPrice(true))
                }
              </div>
            </div>
                {paymentMethod === 'G' && mode === 'sale' &&
            <div className="mb-3 text-blue-gray-700 px-3 pt-2 pb-3 rounded-lg bg-blue-gray-50">
              <div className="flex text-lg font-semibold">
                <div className="flex-grow text-left">NOVČANICE</div>
                <div className="flex text-right">
                  <div className="mr-2">
                    <button  className="text-blue-gray-300 hover:text-pink-500 focus:outline-none" onClick={e => inputCash(0)}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                    </div>
                  <input onInput={e => inputCash(e.target.value)} value={cash} type="text" className="w-28 text-right bg-white shadow rounded-lg focus:bg-white focus:shadow-lg px-2 focus:outline-none" />
                </div>
              </div>
              <hr className="my-2" />
              <div className="grid grid-cols-3 gap-2 mt-2">
                  <button onClick={() => addCash(getTotalPrice(true))} key='modeltotal' className="bg-white rounded-lg shadow hover:shadow-lg focus:outline-none inline-block px-2 py-1 text-sm">+<span> { getTotalPrice(true) }€ </span></button>
                {moneys.map((money) => (
                  <button onClick={() => addCash(money)} key={money} className="bg-white rounded-lg shadow hover:shadow-lg focus:outline-none inline-block px-2 py-1 text-sm">+<span> { money }€ </span></button>
                ))}


              </div>
            </div>}
           {paymentMethod === 'G'  && mode === 'sale' &&
            <div className={"flex mb-3 text-lg font-semibold text-blue-gray-700 rounded-lg py-2 px-3 "+( change >= 0 ? "bg-cyan-50" : "bg-pink-100")}>
              {change >= 0 && <div className="text-cyan-800">VRATITI</div> }
              <div className="text-right flex-grow">
                <span className={change >= 0 ? 'text-cyan-600' : 'text-pink-600'}>{ priceFormat(change) }</span>
              </div>
            </div>}

                        <div className="relative w-full max-w-full mx-auto mt-5 mb-4">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="absolute top-0 bottom-0 w-5 h-5 my-auto text-gray-400 right-3"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <select
                              value={printType}
                              onChange={e => setPrintType(e.target.value)}
                              className="w-full px-3 py-2 text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none appearance-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2">
                             <option key={'T'} value={'T'}>POS printer</option>
                              <option key={'P'} value={'P'}>A4 Printer</option>
                          </select>
                        </div>
              <div className="relative w-full max-w-full mx-auto mt-5 mb-4">
                  <textarea onInput={e => setNote(e.target.value)} value={note} type="text" placeholder="Napomena....."
                         className="w-full px-3 py-2 text-sm text-gray-600 bg-white border rounded-lg shadow-sm outline-none appearance-none focus:ring-offset-2 focus:ring-indigo-600 focus:ring-2"/>
              </div>


              {paymentMethod === 'G' && mode === 'sale' ? (
                  <button onClick={() => handleFinishClick()} disabled={processing || confirming || change < 0 || cartItems.length <= 0 || amountMismatch}
                          className={" font-bold text-base rounded-sm w-full py-3 focus:outline-none "+(change >= 0 && cartItems.length > 0 && !amountMismatch ? "bg-primary hover:bg-yellow-600 text-black" : "bg-secondary text-gray-500")}>
                    { processing || confirming ? 'Procesuiranje..' : 'ZAVRŠI'}
                </button>) : (<button onClick={() => handleFinishClick()} disabled={processing || confirming || cartItems.length <= 0 || amountMismatch} className={" font-bold text-base rounded-sm w-full py-3 focus:outline-none " + (amountMismatch ? "bg-secondary text-gray-500" : "bg-primary hover:bg-yellow-600 text-black")}>
                    { processing || confirming ? 'Procesuiranje..' : 'ZAVRŠI'}
                </button>)}

          </div>

                <div>

                </div>
            </div>
                    </div>
                </div>
            </>
            }

            <TeyaPaymentModal
                show={showCardPaymentModal}
                amount={totalFromQuote(confirmedQuote)}
                onSuccess={handleCardPaymentSuccess}
                onManualConfirm={handleCardPaymentManual}
                onCancel={handleCardPaymentCancel}
                onClose={handleCardPaymentCancel}
            />

            <TeyaRefundModal
                show={showRefundModal}
                amount={completedPayment ? parseFloat(completedPayment.amount) : 0}
                gatewayPaymentId={completedPayment?.gatewayPaymentId}
                onSuccess={handleRefundSuccess}
                onCancel={handleRefundCancel}
            />
        </>
    )
}

export default InvoiceSettingsModal
